import { Organization } from 'types'

export const analyzeDiscovery = (params: Organization) => {
  const hasValue = []
  if (params.website) hasValue.push('Website')
  if (params.street) hasValue.push('Street')
  if (params.city) hasValue.push('City')
  if (params.state) hasValue.push('State')
  if (params.zip) hasValue.push('Zip')
  if (params.cmsUsed) hasValue.push('CMS Used')
  if (params.socialProfiles || (params && params.social && Array.isArray(params.social) && params.social.length > 0))
    hasValue.push('Active Social Profiles')
  // if (params && params.social && Array.isArray(params.social) && params.social.length > 0) hasValue.push('Social')
  if (params.marketingObjective) hasValue.push('Marketing Objective')
  if (params.geoTargeting) hasValue.push('Geographic Targeting')
  const decimalProgress = hasValue.length / 9
  const percentage = parseFloat((decimalProgress * 100).toFixed(0)) // Convert to integer percentage and ensure it's a number
  const fieldsCompleted = hasValue.length
  return { progress: percentage, completed: fieldsCompleted }
}
